module.exports = __webpack_public_path__ + "b9812184f85d7bc6e5d8d82b68792f1a.jpg";